import BaseAPIService from './BaseAPIService';

export default class StoryService extends BaseAPIService {
    constructor() {
        super();
    }

    async getStories(limit = 10, next = "") {
        const query = require('@/graphql/queries/stories.gql');
        const variables = {
            limit,
            next
        }
        const result = await this.query({ query, variables });
        return result.data.stories;
    }
}
